export const GROUP_FIELDS_SUCCESS = 'GROUP_FIELDS_SUCCESS'
export const GROUP_FIELDS_REQUEST = 'GROUP_FIELDS_FETCHING'
export const GROUP_FIELDS_ERROR = 'GROUP_FIELDS_ERROR'
export const GROUP_FIELDS_CLEAR = 'GROUP_FIELDS_CLEAR'
